import { motion, useTransform, useScroll } from "framer-motion";
import { useRef, useEffect } from "react";
import { useNav } from "../../context/nav-context";
import "../../assets/css/steps.css";
// import bg from "../../assets/img/steps-bg.png";
import { useInView } from "react-intersection-observer";
import "animate.css";
import "../../assets/css/steps.css";

const Steps = () => {
  return (
    <div className="bg-lighta p-2 rounded-4">
      <div className="d-flex justify-content-center">
        <span className="fw-400 text-uppercase text-light"></span>
      </div>
      <HorizontalScrollCarousel />
      <div className="d-flex justify-content-center" id="transformations">
        <span className="fw-400 text-uppercase text-light"></span>
      </div>
    </div>
  );
};

const HorizontalScrollCarousel = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });
  const { setActiveLink } = useNav();
  // Update activeLink to "journey" when this section is in view
  useEffect(() => {
    if (inView) {
      setActiveLink("aligners");
    }
  }, [inView, setActiveLink]);

  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-60%"]);

  return (
    <section
      ref={targetRef}
      className="position-relative bg-ligh-dark rounded-4"
      style={{ height: "170vh" }}
      id="aligners"
    >
      <div
        ref={ref}
        className={`d-flex justify-content-between align-items-center p-5 ${
          inView ? "animate__animated animate__fadeIn" : ""
        }`}
        style={{ marginBottom: "-150px" }}
      >
        <div>
          <p
            className={`fs-44 text-white text-center text-lg-start uncover-headings`}
          >
            Uncover the <br /> benefits of clear aligners
          </p>
        </div>
        <div>
          {/* <button
                        type="button"
                        className="btn-theme mt-3 d-none d-lg-block"
                        style={{ cursor: "pointer" }}
                    >
                        Learn More
                    </button> */}
        </div>
      </div>
      <div className="position-sticky top-0 d-flex align-items-center overflow-hidden abc">
        <motion.div style={{ x }} className="d-flex gap-4" id="moving-div">
          {cards.map((card, index) => {
            return <Card card={card} index={index} key={card.id} />;
          })}
        </motion.div>
      </div>
    </section>
  );
};

const Card = ({ card, index }) => {
  return (
    <div
      key={card.id}
      className={`group slider-bg${index} position-relative overflow-hidden rounded-4`}
      style={{
        width: "70vw",
        // height: "80vh",
        marginTop: "80px",
        // backgroundImage: `url(${card.url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="position-absolute top-0 start-0 w-100 h-100 d-grid justify-content-start align-items-center px-3 py-3 py-md-0 px-md-5">
        <div className="card-content">
          <p className="fs-30 text-light fw-700 title">{card.title}</p>
          <p className="fs-16 text-light fw-300 description">
            {card.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Steps;

const cards = [
  {
    // url: bg,s
    title: "1. Multi-layered Design",
    description:
      "Our clear aligners are engineered with advanced, multi-layered materials that provide a unique combination of flexibility and strength. This design allows for the gradual, precise movement of your teeth while reducing the risk of cracking or breaking under pressure. The multiple layers also enhance the aligners' ability to distribute force evenly across your teeth, improving their effectiveness of treatment and ensuring consistent results. Moreover, this layered approach contributes to their durability, allowing you to use each aligner comfortably for the required duration.",
    id: 1,
  },
  {
    // url: bg,
    title: "2. Virtually Invisible",
    description:
      "Unlike traditional braces, which can trap food particles and stain easily, our clear aligners are designed to resist discoloration. Our aligners incorporate stain-resistant properties, making them easy to maintain even when exposed to staining agents like coffee, tea, or red wine. You can remove the aligners for eating and drinking, which further minimises the risk of stains and helps them maintain a bright, clean appearance throughout your treatment. This quality is particularly important if you want discretion during your treatment. ",
    id: 2,
  },
  {
    // url: bg,
    title: "3. Enhanced Comfort",
    description:
      "Our clear aligners are custom-made to fit snugly over your teeth, eliminating the sharp edges and protruding brackets often associated with traditional braces. This tailored fit reduces irritation to your cheeks or gums, providing a more comfortable experience. Additionally, the smooth, flexible material adapts to the natural contours of your teeth, allowing for a more natural feel. You can also enjoy a less intrusive lifestyle, as the removable design permits easy cleaning and maintains comfort during meals and oral hygiene routines.",
    id: 3,
  },
];
